import React from 'react'
import "../../CSS/Blog/imgPrincipalGrandeInicio.css"


const ConteudoImgPrincipalBlog = () => {
  return (
    <div className='conteudoImgPrincipalBlog'>

            <div className="fundoImgPrincipal"></div>

    </div>
  )
}

export default ConteudoImgPrincipalBlog